






















import Vue from 'vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    props: {
        //  The line item being displayed
        item: {
            type: Object,
            required: true
        },
        matchedFields: {
            type: Array,
            default: null
        }
    },
    computed: {
        ...mapGetters(['csvRowData', 'importOptions']),
        matched(): boolean {
            return (
                this.item.csvField !== null &&
                this.item.sdkField !== null &&
                this.item.csvField !== 'No Match'
            )
        },
        rows(): object {
            //  Once we have csvRowData
            if (this.csvRowData) {
                //  Create temp array of rows
                const clone = window._.cloneDeep(this.csvRowData)

                //  Grab our matched prop, or default to an empty array if null
                const matched = this.matchedFields || []

                //  Our valid keys are the keys NOT in our matched
                const validKeys = Object.keys(clone).filter(
                    (key) => !matched.includes(key)
                )

                //  Make sure we append our current matched field if we have one
                if (this.item.csvField) validKeys.push(this.item.csvField)

                //  So our only valid array will be without these keys
                const temp = {}

                //  Iterate through oue keys and assign to temp
                for (let i = 0; i < validKeys.length; i++) {
                    temp[validKeys[i]] = clone[validKeys[i]]
                }

                //  Create a 'No Match' option
                temp['No Match'] = null

                //  Return rows with 'No Match' option
                return temp
            }

            //  Otherwise return nothing
            return null
        }
    },
    methods: {
        onCsvFieldSelected(field: string): void {
            //  If No Match was chosen, reset
            if (field === 'No Match') return this.reset()

            //  Get our required and matched fields
            const allOptions = this.importOptions

            //  Find the option we need to remove from the other tile
            const tile = allOptions.filter((matched) => {
                return matched.csvField === field
            })

            //  If tile exists, emit the reset event to that tile
            if (tile.length > 0) this.$emit('reset', tile[0].uuid)

            //  Find csvRowData for the selected field
            this.item.csvValue = this.csvRowData[field]

            //  Set the matched data field name
            this.item.csvField = field
        },
        reset(): void {
            this.item.csvValue = null
            this.item.csvField = null
        }
    }
})
